/**
 * Which VITE_* variables the app cannot start without, as plain data and a
 * pure check. Shared by configs/env.ts (runtime, in the browser and tests) and
 * vite.config.ts (at `vite build`, so a missing library-group variable fails
 * the pipeline instead of shipping a blank page). No import.meta.env and no
 * `@/` imports here: vite.config.ts loads this file outside the app bundle.
 */

/** Entra ID sign-in is not optional, and neither is any of these. */
export const REQUIRED = [
  'VITE_MSAL_CLIENT_ID',
  'VITE_MSAL_AUTHORITY_BASE',
  'VITE_MSAL_TENANT_ID',
  'VITE_MSAL_REDIRECT_URL',
  'VITE_API_SCOPE_API_ACCESS',
] as const

/** Blank is a real answer here — it means "same origin". Absent is not. */
export const REQUIRED_MAY_BE_BLANK = ['VITE_API_BASE_URL'] as const

type Checked =
  | (typeof REQUIRED)[number]
  | (typeof REQUIRED_MAY_BE_BLANK)[number]

/** An undefined Azure Pipelines variable arrives as the literal `$(Name)`. */
function unreplaced(value: string | undefined): boolean {
  return value !== undefined && /^\$\(.+\)$/.test(value)
}

/** Names of every required variable that is missing, blank or unreplaced. */
export function findInvalidEnv(
  raw: Partial<Record<Checked, string | undefined>>,
): Checked[] {
  return [
    ...REQUIRED.filter((name) => !raw[name] || unreplaced(raw[name])),
    ...REQUIRED_MAY_BE_BLANK.filter(
      (name) => raw[name] === undefined || unreplaced(raw[name]),
    ),
  ]
}

export function missingEnvMessage(invalid: readonly string[]): string {
  return (
    `Missing environment variables: ${invalid.join(', ')}. ` +
    'Copy .env.example to .env.local and fill it in (deployed builds: the ' +
    'ADO library group feeding azure-pipelines-ui.yml). VITE_API_BASE_URL ' +
    'may be blank, but it must be set.'
  )
}
